"use client";

import { useTranslations } from "next-intl";

import { ResponsiveModal } from "@/components/ui/responsive-modal";
import { AuthForm } from "@/components/auth/AuthForm";
import { hardNavigate, hardReload } from "@/lib/navigation/hard-navigate";

interface AuthModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function AuthModal({ open, onOpenChange }: AuthModalProps) {
  const t = useTranslations("common.auth");

  return (
    <ResponsiveModal
      open={open}
      onOpenChange={onOpenChange}
      title={t("loginOrSignup")}
      drawerHeight="full"
      className="sm:max-w-120"
    >
      <div className="pt-4 pb-[max(2rem,var(--loc-safe-area-inset-bottom))]">
        {/* Remount on open/close to guarantee fresh internal state — avoids
            the user reopening the modal mid-flow on email-signup, etc. */}
        <AuthForm
          key={open ? "open" : "closed"}
          context="modal"
          onSuccess={({ redirectUrl, needsPhone }) => {
            onOpenChange(false);
            if (needsPhone) {
              hardNavigate(redirectUrl);
              return;
            }
            hardReload();
          }}
        />
      </div>
    </ResponsiveModal>
  );
}
